import PropTypes from 'prop-types';

import React, { createRef } from 'react';
import moment from 'moment';
import $ from 'jquery';
import * as Pikaday from 'pikaday';
import classnames from 'classnames';


// XXX This should be placed after require('pikaday') in order to
// override the datepicker styles.
import 'pikaday/css/pikaday.css';
import './index.scss';

var DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';

class Datepicker extends React.Component {
  static displayName = 'Datepicker';

  static propTypes = {
    name: PropTypes.string,
    dateFormat: PropTypes.string.isRequired,
    defaultDateFormat: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    name: 'date',
    defaultDateFormat: DEFAULT_DATE_FORMAT,
    placeholder: '',
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.input = createRef();
  }

  componentDidMount() {
    this._setupDatePicker();
  }

  componentDidUpdate() {
    this._setupDatePicker();
  }

  _setupDatePicker = () => {
    var self = this;

    if (this.pikaday !== undefined) {
      this.pikaday.destroy();
    }

    if (this.props.disabled) {
      return;
    }

    if (this.input && this.input.current) {
      this.pikaday = new Pikaday({
        field: this.input.current,
        firstDay: 1,
        format: this.props.dateFormat,
        minDate: this._minDate(),
        defaultDate: this._defaultDate(),
        setDefaultDate: this._setDefaultDate(),
        onSelect: function (date) {
          var formattedDate = moment(date).format(self.props.defaultDateFormat);
          self.props.onChange(self.props.name, date, formattedDate);
        },
      });
    }
  };

  _defaultDate = () => {
    if (this._date() > this._minDate()) {
      return this._date();
    } else {
      return this._minDate();
    }
  };

  // Highlight default date on date picker
  // only if we have explicitly set it from
  // the component props
  _setDefaultDate = () => {
    return this.props.value !== null;
  };

  _minDate = () => {
    if (this.props.startDate) {
      return moment(
        this.props.startDate,
        this.props.defaultDateFormat
      ).toDate();
    } else {
      return moment().toDate();
    }
  };

  _date = () => {
    if (!this.props.value) {
      return '';
    } else {
      return moment(this.props.value, this.props.defaultDateFormat).toDate();
    }
  };

  _dateForInput = () => {
    if (this._date() === '') {
      return this._date();
    } else {
      return moment(this._date()).format(this.props.dateFormat);
    }
  };

  render() {
    var wrapperClasses = classnames('ui', 'icon', 'input', {
      disabled: this.props.disabled,
    });

    return (
      <div data-testid="datepicker" className={wrapperClasses}>
        <input
          type="text"
          ref={this.input}
          name={this.props.name}
          value={this._dateForInput()}
          placeholder={this.props.placeholder}
          readOnly="readonly"
        />
        <i className="af-calendar outline icon icon-anyfont" />
      </div>
    );
  }
}

export default Datepicker;
